import './journey-cost.css';

const STATUS_COPY = Object.freeze({
  CURRENT: {
    badge: '最新',
    detail: '目前分攤結果有效',
    tone: 'current',
  },
  OUTDATED: {
    badge: '已過期',
    detail: '支出異動後需重新計算',
    tone: 'outdated',
  },
  empty: {
    badge: '尚未計算',
    detail: '尚無分攤結果，請先計算分帳。',
    tone: 'empty',
  },
  calculating: {
    badge: '計算中',
    detail: '正在依目前有效支出計算分攤結果。',
    tone: 'calculating',
  },
  failed: {
    badge: '失敗',
    detail: '分攤計算失敗，請稍後再試。',
    tone: 'failed',
  },
});

/**
 * 分攤計算狀態（使用者可見文案為繁中；raw status 僅 data attr）。
 */
export default function CostCalculationStatus({
  status,
  detail,
  className = '',
}) {
  const key = status == null || status === ''
    ? 'empty'
    : (STATUS_COPY[status] ? status : String(status));
  const copy = STATUS_COPY[key] || STATUS_COPY.empty;
  const detailText = detail || copy.detail;

  return (
    <div
      className={`journey-cost-calc-status is-${copy.tone}${className ? ` ${className}` : ''}`}
      role="status"
      data-testid="cost-calculation-status"
      data-status={status || 'empty'}
    >
      <span className="journey-cost-calc-status__badge">{copy.badge}</span>
      {detailText ? (
        <p className="journey-cost-calc-status__detail">{detailText}</p>
      ) : null}
    </div>
  );
}

export { STATUS_COPY as COST_CALCULATION_STATUS_COPY };
